<template>
    <footer>
        <div class="container">
            <div class="row">
            <div class="col-12 my-4">
                <h6 class="footer-text text-center">Slider Puzzle Vue - 2022.</h6>
            </div>
            </div>
        </div>
    </footer>
</template>

<style scoped>

footer {
  padding: 20px 0;
  background: #f3f3f3
}

</style>